import React from "react";
import styled from "styled-components";
import "firebase/firestore";
import SvgDelete from "../../help/Delete";

const Main = styled.div``;

const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 15px;

  .button-container {
    display: flex;
    justify-content: flex-start;
  }
`;

const Label = styled.p`
  font-weight: bold;
  margin: 3px;
`;
const Select = styled.select`
  margin-bottom: 10px;
  padding: 3px;
  width: 150px;
`;
const Input = styled.input`
  margin-bottom: 10px;
  padding: 3px;
  width: 150px;
`;
const Button = styled.button`
  width: 80px;
  height: 50px;
  margin-bottom: 20px;
  margin-right: 10px;
`;

const OutputContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 500px;

  table {
    font-family: Arial, sans-serif;
    border-collapse: collapse;
    width: 100%;
  }

  tr,
  th,
  td {
    border: 1px solid #dddddd;
    text-align: center;
    padding: 8px;
  }
  td {
    padding: 4px;
  }
  tr:nth-child(even) {
    background-color: #f1f1f1;
  }

  .duration {
    text-align: right;
  }
`;

const SumContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  h2 {
    margin-right: 20px;
  }
`;

const Filters = styled.div`
display: flex;
flex-direction: row`;


const MainDisplay = ({
  skippers,
  setSelSkipper,
  date,
  setDate,
  duration,
  setDuration,
  comment,
  setComment,
  handleSendToFirebase,
  handleShowLogs,
  handleDeleteLog,
  list,
  showList,
  totalDuration,
  yearFrom,
  setYearFrom
}) => {
  return (
    <Main>
      <InputContainer>
        <h1>Sailing Log</h1>
        <Label>Skipper: </Label>
        <Select onChange={(event) => setSelSkipper(event.target.value)}>
          {skippers.map((skipper) => {
            return (
              <option key={skipper} value={skipper}>
                {skipper}
              </option>
            );
          })}
        </Select>
        <Label for="datum">Datum:</Label>
        <Input onChange={(event) => setDate(event.target.value)} value={date} />

        <Label>Trip Dauer / H:</Label>
        <Input
          onChange={(event) => setDuration(event.target.value)}
          value={duration}
          type="number"
        />
        <Label>Kommentar:</Label>
        <Input
          value={comment}
          onChange={(event) => setComment(event.target.value)}
          maxlength="60"
        />
        <div className="button-container">
          <Button onClick={handleSendToFirebase}>Speichern</Button>
          <Button onClick={handleShowLogs}>
            {showList ? "Logs ausblenden" : "Logs anzeigen"}
          </Button>
        </div>
      </InputContainer>
      <Filters>
        <Label>Jahr:</Label>
        <Input value={yearFrom} onChange={(event) => setYearFrom(event.target.value)} style={{width: '30px'}} />
      
      </Filters>
      <OutputContainer>
        {showList && (
          <>
            <table>
              <thead>
                <th>Skipper</th>
                <th>Datum</th>
                <th>Dauer</th>
                <th>Kommentar</th>
                {list.map((entry) => {
                  return (
                    <tr key={entry.id}>
                      <td>{entry.skipper}</td>
                      <td className="duration">{entry.date}</td>
                      <td className="duration">{entry.duration}</td>
                      <td>{entry.comment}</td>
                      <td>
                        <SvgDelete onClick={() => handleDeleteLog(entry.id)} />
                      </td>
                    </tr>
                  );
                })}
              </thead>
            </table>
            <SumContainer>
              {list && <h2>Trips: {list.length}</h2>}
              {list && <h2>Stunden: {totalDuration}</h2>}
            </SumContainer>
          </>
        )}
      </OutputContainer>
    </Main>
  );
};

export default MainDisplay;
